<div class="d-flex align-items-center flex-column h-100 row">
  <div class="col-12 col-md-6 col-xl-4">
    <h1 class="text-start text-md-center mb-4 mt-5" i18n>
      Complete your profile
    </h1>

    @if ((user$ | async); as user) {
      <maptio-member-form
        [member]="user"
        [disableEmailInput]="true"
      ></maptio-member-form>
    }
  </div>
</div>
